/* eslint-disable import/prefer-default-export */
export const getAdditionalSurvey = (rootState, timeuuid) => {
	const { cisview } = rootState;
	const { additionalSurveys } = cisview;
	const { surveys } = additionalSurveys;

	return (surveys || []).find(s => s.timeuuid === timeuuid);
};
